export function getObjectFromSearchParams(search) {
    if (!search) {
        return {};
    }

    return new URLSearchParams(search);
}

/**
 * Сравнивает два набора гет-параметров в виде строк
 * @param {string} query1 - из браузера
 * @param {string} query2 - из объекта с бека
 * @return {boolean}
 */
export function queriesIsEqual(query1, query2) {
    if (query1 === query2) return true;

    // TODO: обработать сброс кеша, случай, когда в строке запроса есть &clear_cache=Y

    try {
        const params1 = getObjectFromSearchParams(query1 ? query1.substring(1) : null);
        const params2 = getObjectFromSearchParams(query2 ? query2.substring(1) : null);
        let result = true;

        if (Object.keys(params1).length !== Object.keys(params2).length) return false;

        Object.keys(params1).forEach((key) => {
            if (params1[key] !== params2[key]) result = false;
        });

        return result;
    } catch (e) {
        console.error(e.message);
        return false;
    }
}
